import { Typography } from '@mui/material'
import { withStyles } from '@mui/styles'

const StyledTypography = withStyles({
    root: {
        color: '#5A5A5A',
        pointerEvents: 'none',
        marginRight: '10px'
    }
  })(Typography);

  export default StyledTypography